import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mt-3" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, " Section ", -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "menu-item px-3" }
const _hoisted_6 = { class: "card-body d-flex flex-column" }
const _hoisted_7 = {
  key: 0,
  class: "position-absolute top-0 start-0 rounded h-100 bg-secondary w-4px"
}
const _hoisted_8 = { class: "ms-5" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "menu-item px-3" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuickAction = _resolveComponent("QuickAction")!
  const _component_ShortPageForm = _resolveComponent("ShortPageForm")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_QuickAction, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  class: "menu-link px-3",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onAddSection && _ctx.onAddSection(...args)))
                }, " Add Section")
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex align-items-center position-relative mb-7",
            key: section.id
          }, [
            (_ctx.selectedDoc.id=== section.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                href: "javascript:void (0);",
                class: "fs-5 text-dark text-hover-primary",
                onClick: ($event: any) => (_ctx.onSelect(section))
              }, _toDisplayString(section.name), 9, _hoisted_9)
            ]),
            _createVNode(_component_QuickAction, { clazz: "w-30px h-30px ms-auto" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    class: "menu-link px-3",
                    onClick: ($event: any) => (_ctx.onUpdate(section))
                  }, " Edit Section", 8, _hoisted_11)
                ])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_Panel, {
      name: _ctx.state.title,
      show: _ctx.state.show,
      onClose: _ctx.onClosePanel
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_ShortPageForm, {
              page: _ctx.state.model,
              id: _ctx.state.id,
              onClosePanel: _ctx.onSavePage
            }, null, 8, ["page", "id", "onClosePanel"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["name", "show", "onClose"])
  ], 64))
}